import {
  LuActivity,
  LuAward,
  LuBed,
  LuCar,
  LuColumns3,
  LuPanelLeft,
  LuMegaphone,
  LuPercent,
  LuAlignCenter,
  LuAlignLeft,
  LuAlignRight,
  LuArchive,
  LuArrowDownRight,
  LuArrowLeft,
  LuArrowRight,
  LuArrowUpRight,
  LuBath,
  LuBell,
  LuBellOff,
  LuBold,
  LuBox,
  LuBriefcase,
  LuCalendar,
  LuCamera,
  LuChartBar,
  LuChartPie,
  LuCheck,
  LuChevronDown,
  LuChevronLeft,
  LuChevronRight,
  LuChevronUp,
  LuCircle,
  LuCircleCheck,
  LuCirclePause,
  LuCircleStop,
  LuCircleX,
  LuCircleHelp,
  LuClock,
  LuCode,
  LuCopy,
  LuCornerUpLeft,
  LuCornerUpRight,
  LuCpu,
  LuCreditCard,
  LuDatabase,
  LuDollarSign,
  LuDownload,
  LuEllipsis,
  LuEllipsisVertical,
  LuExternalLink,
  LuEye,
  LuEyeOff,
  LuFacebook,
  LuFile,
  LuFileText,
  LuFilter,
  LuFlag,
  LuFolder,
  LuFolderPlus,
  LuGitBranch,
  LuGitMerge,
  LuGlobe,
  LuGripVertical,
  LuHash,
  LuHeadphones,
  LuHeart,
  LuHouse,
  LuImage,
  LuInbox,
  LuInfo,
  LuInstagram,
  LuItalic,
  LuKey,
  LuLayoutGrid,
  LuLayers,
  LuLink,
  LuLinkedin,
  LuList,
  LuListOrdered,
  LuLoader,
  LuLock,
  LuLockOpen,
  LuLogOut,
  LuMail,
  LuMapPin,
  LuMaximize,
  LuMenu,
  LuMessageCircle,
  LuMessageSquare,
  LuMic,
  LuMinimize,
  LuMinus,
  LuMonitor,
  LuMoon,
  LuMousePointer,
  LuMusic,
  LuOctagonAlert,
  LuPackage,
  LuPaperclip,
  LuPause,
  LuPencil,
  LuPhone,
  LuPlay,
  LuPlus,
  LuPower,
  LuQrCode,
  LuRefreshCw,
  LuRepeat,
  LuRotateCcw,
  LuRotateCw,
  LuRuler,
  LuSave,
  LuSearch,
  LuSend,
  LuServer,
  LuSettings,
  LuShare,
  LuShield,
  LuShoppingBag,
  LuShuffle,
  LuSkipForward,
  LuSlash,
  LuSlidersHorizontal,
  LuSmartphone,
  LuTablet,
  LuSmile,
  LuSquare,
  LuSquareCheck,
  LuStar,
  LuStrikethrough,
  LuSun,
  LuTag,
  LuTarget,
  LuThermometer,
  LuFlame,
  LuYoutube,
  LuToggleLeft,
  LuToggleRight,
  LuTrash2,
  LuTrendingDown,
  LuTrendingUp,
  LuTriangleAlert,
  LuTruck,
  LuType,
  LuUnderline,
  LuUpload,
  LuUser,
  LuUserCheck,
  LuUserPlus,
  LuUsers,
  LuVideo,
  LuWifi,
  LuWifiOff,
  LuX,
  LuZap,
  LuZoomIn,
  LuZoomOut,
} from 'react-icons/lu'

import type { IconPack } from '../types'

export const lucidePack: IconPack = {
  // Navigation
  'home': LuHouse,
  'menu': LuMenu,
  'chevron-down': LuChevronDown,
  'chevron-left': LuChevronLeft,
  'chevron-right': LuChevronRight,
  'chevron-up': LuChevronUp,
  'arrow-left': LuArrowLeft,
  'arrow-right': LuArrowRight,
  'arrow-up-right': LuArrowUpRight,
  'arrow-down-right': LuArrowDownRight,
  'corner-up-left': LuCornerUpLeft,
  'corner-up-right': LuCornerUpRight,
  'external-link': LuExternalLink,
  'log-out': LuLogOut,
  'globe': LuGlobe,
  'map-pin': LuMapPin,

  // Actions
  'plus': LuPlus,
  'minus': LuMinus,
  'x': LuX,
  'check': LuCheck,
  'check-circle': LuCircleCheck,
  'check-square': LuSquareCheck,
  'x-circle': LuCircleX,
  'search': LuSearch,
  'zoom-in': LuZoomIn,
  'zoom-out': LuZoomOut,
  'filter': LuFilter,
  'refresh': LuRefreshCw,
  'rotate-ccw': LuRotateCcw,
  'rotate-cw': LuRotateCw,
  'repeat': LuRepeat,
  'shuffle': LuShuffle,
  'download': LuDownload,
  'upload': LuUpload,
  'share': LuShare,
  'copy': LuCopy,
  'save': LuSave,
  'edit': LuPencil,
  'trash': LuTrash2,
  'archive': LuArchive,
  'send': LuSend,
  'drag': LuGripVertical,
  'maximize': LuMaximize,
  'minimize': LuMinimize,
  'mouse-pointer': LuMousePointer,
  'power': LuPower,

  // Communication
  'mail': LuMail,
  'inbox': LuInbox,
  'message-circle': LuMessageCircle,
  'message-square': LuMessageSquare,
  'phone': LuPhone,
  'video': LuVideo,
  'mic': LuMic,
  'headphones': LuHeadphones,
  'bell': LuBell,
  'bell-off': LuBellOff,

  // Media & Content
  'image': LuImage,
  'camera': LuCamera,
  'file': LuFile,
  'file-text': LuFileText,
  'folder': LuFolder,
  'folder-plus': LuFolderPlus,
  'paperclip': LuPaperclip,
  'link': LuLink,
  'music': LuMusic,
  'play': LuPlay,
  'pause': LuPause,
  'pause-circle': LuCirclePause,
  'stop-circle': LuCircleStop,
  'skip-forward': LuSkipForward,

  // Data & Analytics
  'bar-chart': LuChartBar,
  'pie-chart': LuChartPie,
  'trending-up': LuTrendingUp,
  'trending-down': LuTrendingDown,
  'activity': LuActivity,
  'award': LuAward,
  'bed': LuBed,
  'car': LuCar,
  'columns': LuColumns3,
  'panel-left': LuPanelLeft,
  'megaphone': LuMegaphone,
  'percent': LuPercent,
  'target': LuTarget,
  'database': LuDatabase,
  'grid': LuLayoutGrid,
  'list': LuList,
  'list-ordered': LuListOrdered,
  'hash': LuHash,
  'layers': LuLayers,
  'sliders': LuSlidersHorizontal,

  // Users & People
  'user': LuUser,
  'user-plus': LuUserPlus,
  'user-check': LuUserCheck,
  'users': LuUsers,
  'smile': LuSmile,

  // Business & Commerce
  'briefcase': LuBriefcase,
  'shopping-bag': LuShoppingBag,
  'credit-card': LuCreditCard,
  'dollar-sign': LuDollarSign,
  'tag': LuTag,
  'package': LuPackage,
  'truck': LuTruck,
  'box': LuBox,

  // Security & Status
  'lock': LuLock,
  'unlock': LuLockOpen,
  'slash': LuSlash,
  'key': LuKey,
  'shield': LuShield,
  'eye': LuEye,
  'eye-off': LuEyeOff,
  'alert-circle': LuInfo,
  'alert-octagon': LuOctagonAlert,
  'alert-triangle': LuTriangleAlert,
  'info': LuInfo,
  'help-circle': LuCircleHelp,
  'flag': LuFlag,
  'circle': LuCircle,
  'square': LuSquare,

  // Settings & Tools
  'settings': LuSettings,
  'tool': LuSettings,
  'code': LuCode,
  'cpu': LuCpu,
  'server': LuServer,
  'wifi': LuWifi,
  'wifi-off': LuWifiOff,
  'smartphone': LuSmartphone,
  'qr-code': LuQrCode,
  'tablet': LuTablet,
  'thermometer': LuThermometer,
  'flame': LuFlame,
  'youtube': LuYoutube,
  'toggle-left': LuToggleLeft,
  'toggle-right': LuToggleRight,
  'loader': LuLoader,
  'calendar': LuCalendar,
  'clock': LuClock,

  // Appearance
  'sun': LuSun,
  'moon': LuMoon,
  'heart': LuHeart,
  'star': LuStar,
  'zap': LuZap,

  // Text Formatting
  'bold': LuBold,
  'italic': LuItalic,
  'underline': LuUnderline,
  'strikethrough': LuStrikethrough,
  'type': LuType,
  'align-left': LuAlignLeft,
  'align-center': LuAlignCenter,
  'align-right': LuAlignRight,

  // Version Control
  'git-branch': LuGitBranch,
  'git-merge': LuGitMerge,

  // Social / Brand
  'facebook': LuFacebook,
  'instagram': LuInstagram,
  'linkedin': LuLinkedin,
  'monitor': LuMonitor,

  // Specialty
  'bath': LuBath,
  'ruler': LuRuler,
  'more-horizontal': LuEllipsis,
  'more-vertical': LuEllipsisVertical,
}
